module.exports = "\n<Radio v-model=\"selected\" :type=\"type\" :style=\"editorStyle\" :id=\"id\">{{ innerText }}</Radio>\n";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/components/radio/src/index.vue
// module id = 2322
// module chunks = 38